import React from 'react'
import './MessageCodes.css'

const MessageAY3 = (props) => {

    return (
        <div style={{ width: "fit-content" }}>
            <div
                id="main-tab1"
                style={{padding : '4px' , fontWeight : '700'}}
                className='A3f'
                dangerouslySetInnerHTML={{ __html: props.item.text }}  // Allowing raw HTML
            />

        </div>
    )
}

export default MessageAY3
